
const DashboardNavbar = () => {
    return (
        <header className="flex items-center h-14 gap-4 border-b border-border px-4 lg:px-6">
            navbar
        </header>
    )
};

export default DashboardNavbar
